/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageQuestion: {
  name: 'bubble-message-question';
  data: string;
} = {
  name: 'bubble-message-question',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8.277l-4.762 2.858A1 1 0 0 1 2 21V5Zm18 0H4v14.234l3.248-1.949A2 2 0 0 1 8.277 17H20V5Zm-7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2-6a1 1 0 1 1 1.479.878c-.31.17-.659.413-.94.741-.286.334-.539.8-.539 1.381v.5a1 1 0 1 0 2 0v-.494a.303.303 0 0 1 .057-.085c.077-.09.208-.193.382-.288A3 3 0 1 0 9 9a1 1 0 0 0 2 0Zm1.999 3.011v-.004.005Z" fill="currentColor"/></svg>`,
};
